import React from 'react';

import PeopleListItem from '/component/base/PeopleListItem';

interface PeopleListContentProps {
  data: {
    clients?: any[];
    coaches?: any[];
    currentCount: number;
    target: number;
  };
  titleProps: {
    getTitle: () => string;
  };
  isComplete: boolean;
}

const PeopleListContent: React.FC<PeopleListContentProps> = ({
  data = {clients: [], coaches: [], currentCount: 0, target: 0},
  titleProps = {getTitle: () => ''},
  isComplete = false,
}) => {
  const peopleList = data.clients || data.coaches;

  return (
    <PeopleListItem
      canExpand={false}
      currentCount={data.currentCount}
      hasCheckbox
      isChecked={isComplete}
      label={titleProps.getTitle()}
      oneLineLayout={data.target <= 5}
      peopleList={peopleList}
      readonly
      targetCount={data.target}
    />
  );
};

export default PeopleListContent;
